import { MdInfo } from "react-icons/md";
import { Tooltip, TooltipText } from "./index.styled";

interface TooltipWarningProps {
    message: string;
    position?: 'top' | 'right' | 'bottom' | 'left';
    marginLeft?: string;
}

const TooltipWarning: React.FC<TooltipWarningProps> = ({
    message,
    position = 'top',
    marginLeft = '0px'
}) => {
  return (
    <Tooltip marginLeft={marginLeft}>
      <MdInfo />
      <TooltipText className="tooltipText" position={position}>{message}</TooltipText>
    </Tooltip>
  );
};

export default TooltipWarning;
